export interface BrowserNavigator extends Navigator {
  browserLanguage?: string;
}

const getBrowserLocale = (navigator: BrowserNavigator) => {
  let browserLanguage;

  if (navigator.languages) {
    const [firstLanguage] = navigator.languages;
    browserLanguage = firstLanguage;
  } else {
    browserLanguage = navigator.language || navigator.browserLanguage;
  }

  const currentLocale = browserLanguage?.split('-')[0] || 'es';

  return currentLocale;
};

export { getBrowserLocale };
